import React, { useState } from 'react';

const News = ({ isVisible, news, isLoadingData, Icons }) => {
    // مدیریت استیت داخلی برای نمایش مودال خبر انتخاب شده
    const [selectedNews, setSelectedNews] = useState(null);

    return (
        <div id="page-news" className={`page-section ${isVisible ? '' : 'hidden-page'}`}>
            <div className="container mx-auto px-4 py-6 md:py-12 fade-in">
                 <div className="flex items-center gap-4 mb-8">
                    <div className="h-1 w-12 bg-yellow-500 rounded-full"></div>
                    <h3 className="text-3xl font-black text-white">اخبار و اطلاعیه‌ها</h3>
                 </div>

                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {/* نمایش لودینگ فقط زمانی که دیتایی نداریم */}
                    {isLoadingData && news.length === 0 ? (
                        <div className="col-span-full text-center py-12 flex flex-col items-center justify-center gap-4">
                             <Icons.Loader size={32} className="text-yellow-500" />
                             <p className="text-slate-400 text-sm animate-pulse">در حال دریافت اخبار...</p>
                        </div>
                    ) : news.length === 0 ? (
                        <div className="col-span-full text-center py-12 bg-slate-800/30 rounded-2xl border border-dashed border-slate-700">
                            <Icons.FileText className="w-12 h-12 text-slate-600 mx-auto mb-3" />
                            <p className="text-slate-500">هیچ خبری منتشر نشده است.</p>
                        </div>
                    ) : (
                        news.map((item) => (
                            <div 
                                key={item.id} 
                                className="note-card group cursor-pointer w-full"
                                onClick={() => setSelectedNews(item)}
                            >
                                <div className="p-6 flex flex-col h-full relative z-10 w-full min-w-0">
                                    <div className="flex items-center justify-between mb-4">
                                        <span className="text-xs font-bold text-yellow-500 bg-yellow-500/10 border border-yellow-500/20 px-3 py-1 rounded-full">
                                            {item.created_at ? new Date(item.created_at).toLocaleDateString('fa-IR') : 'جدید'}
                                        </span>
                                        <div className="h-8 w-8 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 group-hover:text-white transition-colors">
                                             <Icons.FileText size={16} />
                                        </div>
                                    </div>
                                    <h3 className="text-xl font-bold text-white mb-3 group-hover:text-yellow-500 transition-colors truncate">{item.title}</h3>
                                    <p className="text-slate-400 text-sm leading-relaxed mb-6 flex-grow line-clamp-3 break-words min-w-0">{item.text}</p>
                                    <button className="text-yellow-500 font-bold hover:text-white flex items-center gap-1 text-sm mt-auto self-end group/btn transition-colors">
                                        ادامه مطلب
                                        <Icons.ChevronLeft size={16} className="transition-transform group-hover/btn:-translate-x-1" />
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                 </div>

                 {/* مودال نمایش جزئیات خبر */}
                 {selectedNews && (
                     <div className="fixed inset-0 z-[100] modal-backdrop flex items-center justify-center px-4" onClick={() => setSelectedNews(null)}>
                         <div className="modal-content glass-panel w-full max-w-2xl rounded-3xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh] bg-[#0f172a]" onClick={e => e.stopPropagation()}>
                             <div className="p-6 border-b border-slate-700 flex justify-between items-center bg-slate-900/50">
                                 <h3 className="text-xl font-bold text-white">{selectedNews.title}</h3>
                                 <button onClick={() => setSelectedNews(null)} className="text-slate-400 hover:text-red-500 transition-colors p-2">
                                     <Icons.X size={24} />
                                 </button>
                             </div>
                             <div className="p-8 overflow-y-auto custom-scrollbar text-slate-300 leading-8 whitespace-pre-wrap text-justify break-words">
                                 {selectedNews.text}
                             </div>
                             <div className="p-4 border-t border-slate-700 bg-slate-900/30 text-left flex justify-between items-center">
                                 <span className="text-sm text-slate-500">نویسنده: {selectedNews.author || 'مدیریت'}</span>
                                 <span className="text-sm text-slate-500">{new Date(selectedNews.created_at).toLocaleDateString('fa-IR')}</span>
                             </div>
                         </div>
                     </div>
                 )}
            </div>
        </div>
    );
};

export default News;